import React from "react";
import { styled } from "@linaria/react";
import { FlexColumn, FlexRow } from "components/rui/layout";
import {
  SectionContainer,
  SectionInner,
  TextContainer,
} from "components/rhombus-UI/theme/containers";
import { StaticImage } from "gatsby-plugin-image";

const Card = styled(FlexRow)`
  display: flex;
  width: 100%;
  min-height: 513px;
  padding: 48px;
  gap: 48px;
  background-color: var(--neutral-100);
  border-radius: 12px;
  overflow: hidden;
  align-items: center;

  .card-image {
    object-fit: contain;
    height: 513px;
    flex-shrink: 0;
    width: 458px;
    border-radius: 12px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;

    .card-image {
      object-fit: cover;
      width: 100%;
      border-radius: 1rem;
      height: 250px;
    }
  }
`;

const CardContent = styled(FlexColumn)`
  gap: 48px;
  justify-content: center;
`;

const Quote = styled.q`
  color: var(--primary-bg);
  font-size: 28px;
  font-weight: 500;
  line-height: 2;
  font-family: var(--headerFontFamily);
  margin: 0;

  span {
    color: var(--blue-500);
  }

  @media (max-width: 1150px) {
    font-size: 24px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const AuthorRow = styled(FlexRow)`
  align-items: center;
  gap: 28px;
`;

const CaseStudyCard = () => {
  return (
    <SectionContainer>
      <SectionInner>
        <Card>
          <StaticImage
            src="./assets/egyptian-motor-hotel-min.png"
            className="card-image"
            alt="Exterior of Egyptian Motor Hotel"
            loading="lazy"
          />
          <CardContent>
            <Quote>
              Rhombus has helped us drastically improve the security we have on
              property. Due to its abilities, it allows us to{" "}
              <span>
                <b>cut out at least 10-15 hours of playback time.</b>
              </span>{" "}
              This is such a wonderful system and I truly don't know how I would
              operate without it—especially with its easy functionality.
            </Quote>
            <AuthorRow>
              <StaticImage
                src="./assets/egyptian-motor-hotel-logo.png"
                alt="Egyptian Motor Hotel logo"
                width={108}
                height={53}
                loading="lazy"
              />
              <TextContainer>
                <b>Tamara Vildosola</b>
                <p>General Manager at Egyptian Motor Hotel</p>
              </TextContainer>
            </AuthorRow>
          </CardContent>
        </Card>
      </SectionInner>
    </SectionContainer>
  );
};

export default CaseStudyCard;
